import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable'
import { Page } from '../../Pages'
import { ShowIfRole } from '../../auth/AuthGuard'

const HousingCooperativePage = Loadable(lazy(() => import('./HousingCooperative.jsx')))

const housingCooperativePageRoutes = [
	{
		path: Page.housing_cooperative.path,
		element: (
			<ShowIfRole role={Page.housing_cooperative.auth}>
				<HousingCooperativePage />
			</ShowIfRole>
		),
		auth: Page.housing_cooperative.auth
	}
]

export default housingCooperativePageRoutes
